import React, { useEffect, useState, Fragment, memo } from 'react'
import { Button, Col, Container, Form, Row, Modal, Card } from 'react-bootstrap'
import { useDispatch, useSelector } from 'react-redux'
import {
  configuracionFormAction,
  configuracionFormAction33,
  obtenerAntecedentesCaso,
  ObtenerHitosCaso
} from '../store/actions/caso-general-action'
import { LoadingComponent } from 'recupero-comunes'
import 'recupero-comunes/dist/index.css'
import { obtenerGrillaImplicado } from '../store/actions/implicado-action'
const DatosGenerales = memo(({setDatosCaso, reloadCaso}) => {
  const [loading, setLoading]=useState(false)
  // El hook useSelector (redux) permite acceder al state en nuestro store.
  const data_datos_generales = useSelector((state) => state.casoGeneralReducer)
  const { cfg_form, antecedentesCasos, llaves } = data_datos_generales

  const [showModalContacto, setShowModalContacto] = useState(false);
  const [contactoApoderado, setContactoApoderado] = useState({
    email: '',
    fono: '',
    movil: ''
  });
  const handleCloseContacto = () => setShowModalContacto(false);
  const handleShowContacto = () => {
    const datos = antecedentesCasos?.antecedentesCasos?.[0] || {};

    setContactoApoderado({
      email: datos['EmailApoderadoCia'] || 'No informado',
      fono: datos['FonoApoderadoCia'] || 'No informado',
      movil: datos['MovilApoderadoCia'] || 'No informado'
    });

    setShowModalContacto(true);
  };

  // El hook useDispatch (redux) permite invocar una action.
  const dispatch = useDispatch()
  useEffect(() => {
    if (llaves) {
      setLoading(true)
      let query = Buffer.from(
        JSON.stringify({
          idOrgCaso: llaves['idOrgCaso'],
          idCaso: llaves['idCaso']
        })
      ).toString('base64')
      dispatch(obtenerAntecedentesCaso(query)).then(()=>{
        if (llaves) {
          let query = Buffer.from(
            JSON.stringify({ idform: 7, rutcia:llaves['idOrgCaso']})
          ).toString('base64')
          dispatch(configuracionFormAction(query))
        }
      }).then(()=>{
        if (llaves) {
          let query = Buffer.from(
            JSON.stringify({ idform: 33, rutcia:llaves['idOrgCaso']})
          ).toString('base64')
          dispatch(configuracionFormAction33(query))
        }
      })
      .then(()=>{
        let query = Buffer.from(
          JSON.stringify({
            idOrgCaso: llaves['idOrgCaso'],
            idCaso: llaves['idCaso']
          })
        ).toString('base64')
        dispatch(obtenerGrillaImplicado(query))
      })
      // .then(()=>{
      //   let query = Buffer.from(
      //     JSON.stringify({
      //       "tipoGestion":235001,
      //        "idOrganizacion":llaves['idOrgCaso'],
      //       "idCaso":llaves['idCaso'], 
      //     })
      //   ).toString('base64')
      //   dispatch(ObtenerHitosCaso(query))
      // })
      .then(()=>setLoading(false))
    }
  }, [dispatch, llaves, reloadCaso])

  useEffect(() => {
    if (antecedentesCasos && setDatosCaso) {
      setDatosCaso(antecedentesCasos?.antecedentesCasos[0]);
    }
  }, [antecedentesCasos])


  return (
    <>
      <LoadingComponent show={loading}/>
    
   
      {cfg_form ? (
        <Form.Group className='mb-3'>
        <div>
          <Row>
            <Col>
              <Form.Label
                className='mb-0'
                style={{ fontWeight: 'bold', fontSize: '14px' }}
              >
                {cfg_form.cfg_form['gestcasosrecup-lbl-siniestro']} / {cfg_form.cfg_form['gestcasosrecup-lbl-patente']}
              </Form.Label>{' '}
              <br />
              <Form.Text className='mb-3'>
                {antecedentesCasos && antecedentesCasos.length !== 'undefined'
                  ? (antecedentesCasos?.antecedentesCasos[0]['Siniestro'] + " / " + antecedentesCasos?.antecedentesCasos[0]['Patente'])
                  : null}
              </Form.Text>
            </Col>
            <Col>
              <Form.Label
                className='mb-0'
                style={{ fontWeight: 'bold', fontSize: '14px' }}
              >
                {cfg_form.cfg_form['gestcasosrecup-lbl-fechasiniestro']}
              </Form.Label>
              <br />
              <Form.Text className='mb-3' style={{ fontSize: '14px' }}>
                {antecedentesCasos && antecedentesCasos.length !== 'undefined'
                  ? antecedentesCasos.antecedentesCasos[0][
                      'FechaSiniestroFormat'
                    ]
                  : null}
              </Form.Text>
            </Col>
            <Col>
              <Form.Label
                className='mb-0'
                style={{ fontWeight: 'bold', fontSize: '14px' }}
              >
                {cfg_form.cfg_form['gestcasosrecup-lbl-tiposiniestro']}
              </Form.Label>
              <br />
              <Form.Text className='mb-3' style={{ fontSize: '14px' }}>
                {antecedentesCasos && antecedentesCasos.length !== 'undefined'
                  ? antecedentesCasos.antecedentesCasos[0]['TipoSiniestro']
                  : null}
              </Form.Text>
            </Col>
            <Col>
              <Form.Label
                className='mb-0'
                style={{ fontWeight: 'bold', fontSize: '14px' }}
              >
                {cfg_form.cfg_form['gestcasosrecup-lbl-situacionsiniestro']}
              </Form.Label>
              <br />
              <Form.Text className='mb-3' style={{ fontSize: '14px' }}>
                {antecedentesCasos && antecedentesCasos.length !== 'undefined'
                  ? antecedentesCasos.antecedentesCasos[0]['EstadoSiniestro']
                  : null}
              </Form.Text>
            </Col>
            <Col>
              <Form.Label
                className='mb-0'
                style={{ fontWeight: 'bold', fontSize: '14px' }}
              >
                {cfg_form.cfg_form['gestcasosrecup-lbl-tipogestion']}
              </Form.Label>
              <br />
              <Form.Text className='mb-3' style={{ fontSize: '14px' }}>
                {antecedentesCasos && antecedentesCasos.length !== 'undefined'
                  ? antecedentesCasos.antecedentesCasos[0]['TipoGestion']
                  : null}
              </Form.Text>
            </Col>
          </Row>
          <Row md='10'>
            <Col>
              <Form.Label
                className='mt-3 mb-0'
                style={{ fontWeight: 'bold', fontSize: '14px' }}
              >
                {cfg_form.cfg_form['gestcasosrecup-lbl-ciudadocu']}
              </Form.Label>
              <br />
              <Form.Text className='mb-3' style={{ fontSize: '14px' }}>
                {antecedentesCasos && antecedentesCasos.length !== 'undefined'
                  ? antecedentesCasos.antecedentesCasos[0]['CiudadOcurrencia']
                  : null}
              </Form.Text>
            </Col>
            <Col>
              <Form.Label
                className='mt-3 mb-0'
                style={{ fontWeight: 'bold', fontSize: '14px' }}
              >
                {cfg_form.cfg_form['gestcasosrecup-tab-detcaso-politem']}
              </Form.Label>
              <br />
              <Form.Text className='mb-3' style={{ fontSize: '14px' }}>
                {antecedentesCasos && antecedentesCasos.length !== 'undefined'
                  ? antecedentesCasos.antecedentesCasos[0]['Poliza'] +
                    ' / ' +
                    antecedentesCasos.antecedentesCasos[0]['Item']
                  : null}
              </Form.Text>
            </Col>
            <Col>
              <Form.Label
                className='mt-3 mb-0'
                style={{ fontWeight: 'bold', fontSize: '14px' }}
              >
                {cfg_form.cfg_form['gestcasosrecup-lbl-contratante']}
              </Form.Label>
              <br />
              <Form.Text className='mb-3' style={{ fontSize: '14px' }}>
                {antecedentesCasos && antecedentesCasos.length !== 'undefined'
                  ? antecedentesCasos.antecedentesCasos[0]['NombreContratante']
                  : null}
              </Form.Text>
            </Col>
            <Col>
              <Form.Label
                className='mt-3 mb-0'
                style={{ fontWeight: 'bold', fontSize: '14px' }}
              >
                {cfg_form.cfg_form['gestcasosrecup-lbl-seguroter']}
              </Form.Label>
              <br />
              <Form.Text className='mb-3' style={{ fontSize: '14px' }}>
                {antecedentesCasos && antecedentesCasos.length !== 'undefined'
                  ? antecedentesCasos.antecedentesCasos[0]['SeguroTercero']
                  : null}
              </Form.Text>
            </Col>
            <Col>
              <Form.Label
                className='mt-3 mb-0'
                style={{ fontWeight: 'bold', fontSize: '14px' }}
              >
                {cfg_form.cfg_form['gestcasosrecup-lbl-estadocaso']}
              </Form.Label>
              <br />
              <Form.Text className='mb-3' style={{ fontSize: '14px' }}>
                {antecedentesCasos && antecedentesCasos.length !== 'undefined'
                  ? antecedentesCasos.antecedentesCasos[0]['EstadoCaso']
                  : null}
              </Form.Text>
            </Col>
          </Row>
          <Row md='10'>
            <Col>
              <Form.Label
                className='mt-3 mb-0'
                style={{ fontWeight: 'bold', fontSize: '14px' }}
              >
                {cfg_form.cfg_form['gestcasosrecup-lbl-corredor']}
              </Form.Label>
              <br />
              <Form.Text className='mb-3' style={{ fontSize: '14px' }}>
                {antecedentesCasos && antecedentesCasos.length !== 'undefined'
                  ? antecedentesCasos.antecedentesCasos[0]['Corredor']
                  : null}
              </Form.Text>
            </Col>
            <Col>
              <Form.Label
                className='mt-3 mb-0'
                style={{ fontWeight: 'bold', fontSize: '14px' }}
              >
                {cfg_form.cfg_form['gestcasosrecup-lbl-analistarecdef']}
              </Form.Label>
              <br />
              <Form.Text className='mb-3' style={{ fontSize: '14px' }}>
                {antecedentesCasos && antecedentesCasos.length !== 'undefined'
                  ? antecedentesCasos.antecedentesCasos[0]['AnalistaRecDef']
                  : null}
              </Form.Text>
            </Col>
            <Col>
              <Form.Label
                className='mt-3 mb-0'
                style={{ fontWeight: 'bold', fontSize: '14px' }}
              >
                {cfg_form.cfg_form['gestcasosrecup-lbl-responsable']}
              </Form.Label>
              <br />
              <Form.Text className='mb-3' style={{ fontSize: '14px' }}>
                {antecedentesCasos && antecedentesCasos.length !== 'undefined'
                  ? antecedentesCasos.antecedentesCasos[0][
                      'ResponsableAsignado'
                    ]
                  : null}
              </Form.Text>
            </Col>
            <Col>
              <Form.Label
                className='mt-3 mb-0'
                style={{ fontWeight: 'bold', fontSize: '14px' }}
              >
                {cfg_form.cfg_form['gestcasosrecup-lbl-fechaasig']}
              </Form.Label>
              <br />
              <Form.Text className='mb-3' style={{ fontSize: '14px' }}>
                {antecedentesCasos && antecedentesCasos.length !== 'undefined'
                  ? antecedentesCasos.antecedentesCasos[0][
                      'FechaAsignacionFormat'
                    ]
                  : null}
              </Form.Text>
            </Col>
            <Col>
              <Form.Label
                className='mt-3 mb-0'
                style={{ fontWeight: 'bold', fontSize: '14px', cursor: 'pointer' }}
                onClick={handleShowContacto}
              >
                {cfg_form.cfg_form['gestcasosrecup-lbl-apoderadocia'] ? cfg_form.cfg_form['gestcasosrecup-lbl-apoderadocia'] : 'Apoderado Cía'}
              </Form.Label>
              <br />
              <Form.Text className='mb-3' style={{ fontSize: '14px', cursor: 'pointer' }} onClick={handleShowContacto}>
                {antecedentesCasos && antecedentesCasos.length !== 'undefined'
                  ? antecedentesCasos.antecedentesCasos[0]['ApoderadoCia']
                  : null}
              </Form.Text>
            </Col>
          </Row>
        </div>
    </Form.Group>
      ) : null}
      <Modal show={showModalContacto} onHide={handleCloseContacto} centered>
        <Card>
          <Card.Header
            className='mt-0 mb-0'
            as='h6'
            style={{ backgroundColor: '#4F517A', color: 'white' }}
          >
            Contacto Apoderado
          </Card.Header>

          <Card.Body>
            <Row className='mt-2 mb-3'>
              <Col>
                <Form.Label style={{ fontWeight: 'bold' }}>Email:</Form.Label>{' '}
                <Form.Text>{contactoApoderado.email}</Form.Text>
              </Col>
            </Row>
            <Row>
              <Col>
                <Form.Label style={{ fontWeight: 'bold' }}>Fono:</Form.Label>{' '}
                <Form.Text>{contactoApoderado.fono}</Form.Text>
              </Col>
              <Col>
                <Form.Label style={{ fontWeight: 'bold' }}>Móvil:</Form.Label>{' '}
                <Form.Text>{contactoApoderado.movil}</Form.Text>
              </Col>
            </Row>
          </Card.Body>

          <Card.Footer style={{ display: 'flex', justifyContent: 'flex-end' }}>
            <Button variant='secondary' onClick={handleCloseContacto}>
              Cerrar
            </Button>
          </Card.Footer>
        </Card>
      </Modal>
    </>
  )
})

export default DatosGenerales
